module.exports = __webpack_public_path__ + "img/group.836b8be3.png";